(function($, App, Utils, Components){
  'use strict';

  const logger = new Logger("Loader");

  Components.create('Loader', {

    active: true,

    timeout: 300,

    Selectors: {
      main: $('.js-loader')
    },

    Events: {
      show: 'loader:show',
      hide: 'loader:hide'
    },

    init: () => {
      if (!Components.Loader.active) {
        logger.d('Loader component disabled :-( ');
        return
      }
      logger.d('Loader initialized :-) ');
      Components.Loader.setOpts();
      Components.Loader.bindEvents();
    },

    bindEvents: () => {
      Components.on(Components.Loader.Events.show, (e, payload) => {
        logger.d('Showing loader');
        Components.Loader.show(payload);
      });

      Components.on(Components.Loader.Events.hide, (e) => {
        logger.d('Hiding loader');
        Components.Loader.hide();
      } );

    },

    setOpts: () => {
      let data = Utils.jsonDA(Components.Loader.Selectors.main, 'loading');
      logger.i(data);
      Components.Loader.opts = {
        parent: data  && data.parent ? data.parent : '.body',
        classIn: data && data.classes ? data.classes.split(",") : ['in', 'fade-in']
      };

      logger.i(Components.Loader.opts);
    },

    show: (payload) => {
      if ((payload && payload.parent) && payload.parent !== Components.Loader.opts.parent) {
        $(payload.parent).css('position', 'relative');
        Components.Loader.Selectors.main.css('position', 'absolute').appendTo(payload.parent);
        Components.Loader.animate();
      } else {
        Components.Loader.animate();
      }
    },

    hide: () => {
      Components.Loader.animate(true);
    },

    animate: (hide) => {
      if (hide) {
        Components.Loader.Selectors.main.removeClass(Components.Loader.opts.classIn[1]);

        setTimeout(function() {
          Components.Loader.Selectors.main.removeClass(Components.Loader.opts.classIn[0]);
        }, Components.Loader.timeout);

      } else {

        Components.Loader.Selectors.main.addClass(Components.Loader.opts.classIn[0]);

        setTimeout(function() {
          Components.Loader.Selectors.main.addClass(Components.Loader.opts.classIn[1]);
        }, Components.Loader.timeout);

      }

    }

  });

})(jQuery, window.App, window.App.Utils, window.App.Components);